import React from 'react';
import formatDate from 'utils/formatDate';

export default class SparkLineTooltipContent extends React.PureComponent {
  render() {
    return (
      <div className="sparkline-tooltip-content">
        <div>
          <strong>Period starting: {formatDate(this.props.date)}</strong>
        </div>
        <div>
          {this.props.title} <strong>{this.props.value}</strong>
        </div>
      </div>
    );
  }
}
